import chart from "./chart";

// @param points is an array of [x1, y1, x2, y2] where x1 and y1 are coords of
// the point, and x2 and y2 are coords of the control for the curve
export const curvedSmoothing = (points) => {
  let d = "";

  // Filter out coordinates at 0 since those will pull the polygon to the centre
  // of the circle
  const ps = points.reduce((acc, curr) => {
    if (curr[0] === 0) return acc;
    acc.push(curr);
    return acc;
  }, []);

  let i;
  for (i = 0; i < ps.length - 1; i++) {
    if (i === 0) {
      d += "M " + ps[i][0].toFixed(4) + " " + ps[i][1].toFixed(4);
    }

    d += ` C ${ps[i][2].toFixed(4)} ${ps[i][3].toFixed(4)}`; // control start
    d += ` , ${ps[i + 1][2].toFixed(4)} ${ps[i + 1][3].toFixed(4)}`; // control end
    d += ` , ${ps[i + 1][0].toFixed(4)} ${ps[i + 1][1].toFixed(4)}`; // end
  }

  // Close polygon
  d += ` C ${ps[i][2].toFixed(4)} ${ps[i][3].toFixed(4)}`; // control start
  d += ` , ${ps[0][2].toFixed(4)} ${ps[0][3].toFixed(4)}`; // control end
  d += ` , ${ps[0][0].toFixed(4)} ${ps[0][1].toFixed(4)}`; // end

  return d;
};

const serverData = (options = {}) => {
  const chartData = options.chart || chart;

  return [
    {
      name: "server data",
      options: {
        axes: false,
        dots: false,
        scales: 0,
        smoothing: curvedSmoothing,
      },
      captions: {
        "public-artworks": "Public artworks",
        "stochastic-archives": "Stochastic archives",
        "institute-of-chance": "Institute of chance",
        interlude: "Interlude",
        "the-wall-and-the-books": "The wall and the books",
        blackboxing: "Blackboxing",
        "nobody-was-tomorrow": "Nobody was tomorrow",
        "estas-ruinas-que-ves": "Estas ruinas que ves",
        "between-you-and-the-image-of-you-that-reaches-me":
          "Between you and the image of you that reaches me",
        "kaleidoscopic-eye": "Kaleidoscopic Eye",
        "el-donde-estoy-va-desapareciendo":
          "El d\u00f3nde estoy va desapareciendo",
        "never-odd-or-even": "Never odd or even",
        "uncomfortable-objects": "Uncomfortable Objects",
        "what-we-caught-we-threw-away": "What we caught we threw away",
        "vista-de-ojos": "Vista de Ojos",
        "quien-medira-el-espacio-quien-me-dira-el-momento":
          "\u00bfQui\u00e9n medir\u00e1 el espacio, qui\u00e9n me dir\u00e1 el momento?",
        parergon: "Parergon",
        "feathered-changes": "Feathered changes",
        "hypothesis-of-a-tree": "Hypothesis of a tree",
        "to-day": "to-Day",
        "them-inside-the-skin": "Them inside the skin",
        "in-tlilli-in-tlapalli": "In tlilli in tlapalli",
      },
      chart: chartData,
    },
  ];
};

export default serverData;
